








import {
  Component,
  Vue
} from 'vue-property-decorator';
import Navigation from '@/components/Navigation/Navigation.vue';
import Notifications from '@/components/Notifications/Notifications.vue';

@Component({
  components: {
    Navigation,
    Notifications,
  },
})
export default class App extends Vue {}
